module.exports = __webpack_public_path__ + "static/media/chart-line.068d7796.svg";